module.exports = __webpack_public_path__ + "media/images/client/MediaReviews/habr-84dfc9543c9f99016d3c0104ac23d328.svg";